import { render } from "./CascaderNewComponent.vue?vue&type=template&id=4642dd7d"
import script from "./CascaderNewComponent.vue?vue&type=script&lang=js"
export * from "./CascaderNewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__